module.exports = __webpack_public_path__ + "img/prize-05.cbe28c5d.png";